<div style="background-color: whitesmoke" >
<div class="row center">
    <div class="col-xs-12 center">
        <br>
        <h2>audEERING Event App</h2>
        <br>
        Create your own personalized event questionnaire powered by AI.
    </div>
</div>
<br>
<br>
    <div class="row center">
        <div class="col-xs-12 center">
            <a routerLink="/signin"><button *ngIf="!(authState | async).authenticated" class="btn btn-primary" id="button" >Login and Get Started</button></a>
            <a routerLink="/tutorial"><button *ngIf="(authState | async).authenticated" class="btn btn-primary" id="button" >Tutorials</button></a>
            <a routerLink="/events"><button *ngIf="(authState | async).authenticated" class="btn btn-primary" id="button" (click)="onFetchData()" >Events</button></a>
        </div>
    </div>
<br>
<br>
</div>


<hr>
<div class="row center">
    <div class="col-xs-6">
        <h3>Backed by Artificial Intelligence </h3>
        <p> Audio answers will give you the chance to tap into your audience emotions. </p>
    </div>
    <div class="col-xs-6">
        <img class="img img-responsive" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxAZdmeQJmFClm3-JJi57e99XGTNYJ9kNZHcKKTiMD1vyEBUBx" alt="SmartPhone">
    </div>
</div>

<hr>

<div class="row center">
        <div class="col-xs-6">
                <img class="img img-responsive" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0zVPn_KKZ96gDXCFWxa6an1Luw1FEsxBn4rLf-4t_cFm1TCUn" alt="SmartPhone">
        </div>
        <div class="col-xs-6">
            <h3>Fast and Easy </h3>
            <p> Setup your whole event in a minute and use the application to answer the questions. <br>
                Everything is connected. </p>
        </div>
<br>
<hr>
<br>
    <div class="row center">
        <div class="col-xs-12 center">
            <h3> Learn how to create your event </h3>
        Built as a responsive and user-friendly platform, you can learn everything you need on the tutorials.
        </div>
    </div>

<br>
    <div class="row center">
        <div class="col-xs-12 center">
        <a routerLink="/tutorial"><button class="btn btn-primary" id="button" >tutorials</button></a>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/home/home.component.html